import React, { useState, Fragment, useEffect } from 'react';
import { Portal } from 'react-portal';
import classNames from "classnames";
import { func, node, string, bool } from 'prop-types';

const Modal = (props) => {
  const [animatedClass, setAnimatedClass] = useState('');
  const {
    children,
    closePortal,
    position,
    withAnimation,
    className,
  } = props;

  const closePortalHandler = () => {
    const duration = withAnimation ? 500 : 0;
    setAnimatedClass(withAnimation ? 'animateOut' : '');
    setTimeout(() => {
      closePortal();
    }, duration);
  };

  useEffect(() => {
    const body = document.getElementsByTagName('body');
    body[0].classList.add('modal-open');
    return () => {
      body[0].classList.remove('modal-open');
    };
  }, []);
  return (
    <Fragment>
      <Portal>
        <div className="new-modal-overlay" onClick={closePortalHandler} />
        <div className={classNames("new-modal", position, animatedClass, className)}>
          <button className="new-modal__close" onClick={closePortalHandler} />
          {children}
        </div>
      </Portal>
    </Fragment>
  );
};

Modal.propTypes = {
  children: node.isRequired,
  closePortal: func.isRequired,
  position: string,
  withAnimation: bool,
  className: string,
}

Modal.defaultProps = {
  position: '',
  withAnimation: false,
  className: '',
}

export default Modal;
